import React from "react";
import Contents from "./Contents";
import Tabs from "./Tabs";

function Container(props: any) {
    const [selectedTab, setSelectedTab] = React.useState(0)

    return (
        <div className="container">
            <Tabs parentOnClick={setSelectedTab} activeTab={selectedTab}></Tabs>
            <Contents 
                index={selectedTab}
            />
        </div>
    )
}

export default Container